
    export const PRODUCT_IMPRESSION_EVENT_NAME = 'view_item_list';
    export const PRODUCT_CLICK_EVENT_NAME = 'select_item';
    export const PRODUCT_DETAIL_VIEW_EVENT_NAME = 'view_item';
    export const PRODUCT_ADD_TO_CART_EVENT_NAME = 'add_to_cart';
    export const VIEW_CART_EVENT_NAME = 'view_cart';
    export const BEGIN_CHECKOUT_EVENT_NAME = 'begin_checkout';
    export const REVIEW_ORDER_EVENT_NAME = 'add_shipping_info'; 
    export const TRANSACTION_EVENT_NAME = 'purchase';
    export const SEARCH_EVENT_NAME = 'search';
    export const REMOVE_FROM_CART_EVENT_NAME = 'remove-from-cart';
    export const ITEM_BRAND = 'patcraft';
    export const PRODUCT_LIST = 'product list';
    export const IN_STOCK = 'Show In Stock';
    export const FILTER_BY_FACE_WEIGHT_RANGE = 'Filter By Face Weight Range';